export default __webpack_public_path__ + "static/bc_hu_3-9f8a950c2dd0d21063a50cf890dc0a7e.mp4";